import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-drag-handle-icon',
  standalone: true,
  template: `
    <svg
      [attr.width]="width()"
      [attr.height]="height()"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6167 7.34154C15.979 7.34154 17.0834 6.23717 17.0834 4.87487C17.0834 3.51257 15.979 2.4082 14.6167 2.4082C13.2544 2.4082 12.15 3.51257 12.15 4.87487C12.15 6.23717 13.2544 7.34154 14.6167 7.34154Z"
        [attr.fill]="color()" />
      <path
        d="M5.38329 7.34154C6.74559 7.34154 7.84996 6.23717 7.84996 4.87487C7.84996 3.51257 6.74559 2.4082 5.38329 2.4082C4.02099 2.4082 2.91663 3.51257 2.91663 4.87487C2.91663 6.23717 4.02099 7.34154 5.38329 7.34154Z"
        [attr.fill]="color()" />
      <path
        d="M14.6167 17.5915C15.979 17.5915 17.0834 16.4872 17.0834 15.1249C17.0834 13.7626 15.979 12.6582 14.6167 12.6582C13.2544 12.6582 12.15 13.7626 12.15 15.1249C12.15 16.4872 13.2544 17.5915 14.6167 17.5915Z"
        [attr.fill]="color()" />
      <path
        d="M5.38329 17.5915C6.74559 17.5915 7.84996 16.4872 7.84996 15.1249C7.84996 13.7626 6.74559 12.6582 5.38329 12.6582C4.02099 12.6582 2.91663 13.7626 2.91663 15.1249C2.91663 16.4872 4.02099 17.5915 5.38329 17.5915Z"
        [attr.fill]="color()" />
    </svg>
  `,
})
export class DragHandleIconComponent {
  width = input<string>('20');
  height = input<string>('20');
  color = input<string>('#737373');
}
